import styles from './CipherGrid.module.css';

export function CipherGrid() {
  return (
    <div className={styles.frame}>
      <div className={styles.rippleField}>
        {Array.from({ length: 7 }, (_, index) => (
          <span
            key={index}
            className={styles.ripple}
            style={{ ['--delay' as string]: `${index * 2.45}s` }}
          />
        ))}
        <div className={styles.mark}>
          <img src="/brand/trove-keyhole.png" alt="" />
        </div>
      </div>
    </div>
  );
}
